import { Component, OnInit } from '@angular/core';
import { FlowchartPaper_History_Interface } from 'src/app/Interface/FlowchartPaper_History_Interface';
import { Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { Empty_PersoneOffDay_Interface, PersoneOffDay_Interface } from 'src/app/Interface/PersoneOffDay_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FlowcharPaperService } from 'src/app/Service/Flowchart/FlowcharPaper.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonOffDayService } from 'src/app/Service/Person/PersonOffDay.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-PersonOffDayList',
  templateUrl: './PersonOffDayList.component.html',
  styleUrls: ['./PersonOffDayList.component.scss']
})
export class PersonOffDayListComponent implements OnInit {

  Token:String=""
  BaseUrl1:string=""
  BaseUrlCo:string="&id2="
  page:number=0;
  Procssing:boolean=false

  StartSearchDate:string=''
  EndSearchDate:string=''
  SubmitPeriodDate:string='0'
  Filter_Status:string='0'
  Filter_fullname:string=""
  
  modalRef_Delete: any;

  constructor(
    private FlowcharPaper_Service:FlowcharPaperService,
    private Person_Service:PersonOffDayService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
  ) { }


  DataList_Offday:Array<PersoneOffDay_Interface>=[]
  DataList_History:Array<FlowchartPaper_History_Interface>=[]
  Selected_Offday_Record:  PersoneOffDay_Interface=Empty_PersoneOffDay_Interface();

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.BaseUrl1 =  environment.BaseUrl+"flowchart/WorkflowDetail?token="+this.Token+"&id="
    this.Nav_Service.CheckValidPage(this.Token,2195).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

    
  }

  ReadData_Offday(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.Person_Service.GetOffday(this.Token,
      Number(this.SubmitPeriodDate),
      Number(this.Filter_Status),
      this.Filter_fullname,
      StartSearchDate,
      EndSearchDate).subscribe(
      data=>{

        this.DataList_Offday=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  OnGet_Person_Action(model: Array<Persone_List_Interface>)
  {
    this.Filter_fullname = "-1"
    for (let item of model)
    {
      this.Filter_fullname=this.Filter_fullname+","+item.id
    }

    if (model.length == 0)
      this.Filter_fullname=""

  }

  
  ReadData_History(item:PersoneOffDay_Interface){
    this.Procssing=true
    this.FlowcharPaper_Service.History_WorkFlow(this.Token,item.flowchart.makerId).subscribe(
      data=>{
        this.Selected_Offday_Record=item
        this.DataList_History=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Close_Show_History(){
    this.Selected_Offday_Record=Empty_PersoneOffDay_Interface()
  }


  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaDay.xlsx");

  }


}
